import { Dashboard } from "../dashboard"

export const SupportDashboards = ({pageSwap}) => {
    return(
        <Dashboard
            CustomerStage={3}
            pageSwap={pageSwap}
        />
    )
}